import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { Tooltip } from '../library/Tooltip';
import { Chip } from '../library/Chip';

interface Props {
  chip: { label: string; value: string; tooltip?: string };
  selected: boolean;
  handleChipSelection(value: string, selected: boolean): void;
}

export const SurchargeSelectableChip: React.FC<Props> = ({
  chip: { label, value, tooltip },
  selected,
  handleChipSelection,
}: Props) => {
  const { t } = useTranslation();

  if (tooltip)
    return (
      <Tooltip
        key={`${value}-tooltip`}
        placement="top"
        title={<Typography dangerouslySetInnerHTML={{ __html: t(tooltip) }} />}
        leaveDelay={100}
        slotProps={{
          tooltip: {
            sx: {
              p: '16px',
              maxWidth: '320px',
              fontSize: '14px',
              '& ul': {
                m: '0px',
                py: '8px',
                pl: '24px',
              },
            },
          },
        }}
      >
        <Chip
          key={`${value}-chip`}
          onClick={() => handleChipSelection(value, selected)}
          label={t(label)}
          selected={selected}
        />
      </Tooltip>
    );
  return (
    <Chip
      key={`${value}-chip`}
      onClick={() => handleChipSelection(value, selected)}
      label={t(label)}
      selected={selected}
    />
  );
};
